import React from 'react';
import Icon from "./Icon";
import PropTypes from "prop-types";

const FacebookIcon = (props) => {
    return (
        <div className='listing-footer__icon-block' onClick={props.onClick}>
            <Icon
                className='text-white'
                icon='icon-facebook'
                selected={props.selected}
            />
        </div>
    );
}

FacebookIcon.propTypes = {
    selected: PropTypes.bool,
    onClick: PropTypes.func,
}

FacebookIcon.defaultProps = {
    selected: false,
    onClick: () => {}
}

export default FacebookIcon;
